import { motion } from 'framer-motion'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { CheckCircle2, Clock, AlertCircle } from 'lucide-react'
import { Badge } from '@/components/ui/badge'

interface Props {
  tituloEvento: string
  statusInscricao: 'confirmado' | 'pendente' | 'cancelado'
  isPaidEvent: boolean
}

export function InscricaoSucessoCard({
  tituloEvento,
  statusInscricao,
  isPaidEvent
}: Props) {
  const isPendente = statusInscricao === 'pendente'

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-background via-background to-muted/10 p-4">
      <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} className="w-full max-w-md">
        <Card className="border-2 border-primary/20">
          <CardHeader className="text-center">
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: 'spring' }}
              className={`mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full ${
                isPendente ? 'bg-yellow-500/10' : 'bg-primary/10'
              }`}
            >
              {isPendente ? (
                <Clock className="h-8 w-8 text-yellow-600 dark:text-yellow-500" />
              ) : (
                <CheckCircle2 className="h-8 w-8 text-primary" />
              )}
            </motion.div>

            <CardTitle className="text-2xl">
              {isPendente ? 'Inscrição Recebida!' : 'Inscrição Confirmada!'}
            </CardTitle>

            <CardDescription className="mt-2">
              Sua inscrição para o evento <strong>{tituloEvento}</strong> foi realizada com sucesso.
            </CardDescription>

            {isPendente && (
              <Badge variant="outline" className="mt-3 border-yellow-500 bg-yellow-500/10 text-yellow-700 dark:text-yellow-400">
                <AlertCircle className="mr-1 h-3 w-3" />
                Aguardando Confirmação de Pagamento
              </Badge>
            )}
          </CardHeader>

          <CardContent className="space-y-4">
            <div className="rounded-lg bg-muted/50 p-4 text-sm">
              <p className="mb-2 font-medium">Próximos passos:</p>
              <ul className="space-y-1 text-muted-foreground">
                {isPendente && isPaidEvent ? (
                  <>
                    <li>• Seu comprovante de pagamento está sendo analisado</li>
                    <li>• Você receberá uma confirmação após a verificação</li>
                    <li>• Guarde o e-mail de confirmação para apresentar no evento</li>
                  </>
                ) : (
                  <>
                    <li>• Você receberá um e-mail de confirmação em breve</li>
                    <li>• Guarde este e-mail para apresentar no dia do evento</li>
                    <li>• Chegue com antecedência no dia do evento</li>
                  </>
                )}
              </ul>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  )
}